import AppScreen from './components/AppScreen'

export default {
  path: '/app',
  component: AppScreen,
  name: 'App'
}



// WEBPACK FOOTER //
// ./src/app/screens/App/index.js